import React from 'react';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import { ScreeningRecordSourceBadge } from '../components/records/screeningRecordKind';
import { formatDateShort } from '../utils/dateFormat';
import NowName from '../components/shared/NowName';

// Management — Screening Records list (docs/modules/workflow-screening.md
// §記錄層). Every formal screening record: the ones a completed Screening
// request wrote and the ones entered here. Add / edit on the record pages.
const QMScreeningRecords = () => (
  <WorkflowListShell
    backTo="/manage"
    backLabel="Management"
    title="Screening Records"
    subtitle="Completed QM background checks."
    newTo="/qm/screening-records/new"
    newLabel="New Record"
    apiPath="/api/qm/screening-records"
    rowTo={(r) => `/qm/screening-records/${r.id}`}
    searchPlaceholder="Search client group, company, UEN, ultimate parent, UBO or request no…"
    defaultSort={{ key: 'completedOn', direction: 'desc' }}
    showHideCompleted={false}
    emptyText="No screening records"
    columns={[
      { key: 'id', label: 'Record', sortKey: 'id', render: (r) => <span className="font-medium text-blue-700">#{r.id}</span> },
      { key: 'clientGroup', label: 'Client Group', sortKey: 'clientGroup', render: (r) => <NowName value={r.clientGroup} now={r.clientGroupNow} /> },
      { key: 'entities', label: 'Companies', render: (r) => <NowName value={r.entityNames} now={r.entityNamesNow} className="text-slate-600" />, cellTitle: (r) => r.entityNames || '' },
      { key: 'ultimateParent', label: 'Ultimate Parent', render: (r) => r.ultimateParent || '—' },
      { key: 'completedOn', label: 'Completed', sortKey: 'completedOn', render: (r) => formatDateShort(r.completedOn) },
      { key: 'source', label: 'Source', sortKey: 'source', render: (r) => <ScreeningRecordSourceBadge record={r} /> },
      { key: 'doc', label: 'Document', render: (r) => (r.hasScreeningFile
        ? <span className="text-xs text-green-700">Filed</span>
        : <span className="text-xs text-amber-700">Missing</span>) },
    ]}
  />
);

export default QMScreeningRecords;
